import React from "react";
import { MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const regions = [{
  id: 1,
  name: "Miami & Coral Gables"
}, {
  id: 2,
  name: "Homestead & South Dade"
}, {
  id: 3,
  name: "The Beaches & Islands"
}, {
  id: 4,
  name: "North Dade & Aventura"
}, {
  id: 5,
  name: "Doral & West Miami"
}, {
  id: 6,
  name: "Florida Keys & Monroe"
}];
const communities = [{
  regionId: 1,
  name: "Coral Gables"
}, {
  regionId: 1,
  name: "Coconut Grove"
}, {
  regionId: 1,
  name: "Pinecrest"
}, {
  regionId: 1,
  name: "South Miami"
}, {
  regionId: 1,
  name: "Brickell"
}, {
  regionId: 2,
  name: "Homestead"
}, {
  regionId: 2,
  name: "Cutler Bay"
}, {
  regionId: 2,
  name: "Palmetto Bay"
}, {
  regionId: 2,
  name: "Redland"
}, {
  regionId: 3,
  name: "Miami Beach"
}, {
  regionId: 3,
  name: "Key Biscayne"
}, {
  regionId: 3,
  name: "Sunny Isles"
}, {
  regionId: 3,
  name: "Bal Harbour"
}, {
  regionId: 4,
  name: "Aventura"
}, {
  regionId: 4,
  name: "North Miami"
}, {
  regionId: 4,
  name: "Miami Lakes"
}, {
  regionId: 4,
  name: "Opa-locka"
}, {
  regionId: 5,
  name: "Doral"
}, {
  regionId: 5,
  name: "Sweetwater"
}, {
  regionId: 5,
  name: "Westchester"
}, {
  regionId: 5,
  name: "Fontainebleau"
}, {
  regionId: 6,
  name: "Key Largo"
}, {
  regionId: 6,
  name: "Islamorada"
}, {
  regionId: 6,
  name: "Tavernier"
}, {
  regionId: 6,
  name: "Ocean Reef"
}];
export default function NeighborhoodsCommunities() {
  return <section data-section-id="245367" id="service-areas" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-4 text-secondary">
            Miami-Dade Service Areas
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Providing comprehensive home inspections across South Florida. From 
            the urban core to the coastal islands, our certified team is near you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {regions.map((region, i) => <Card key={region.id} data-index={i} className="h-full border-border shadow-sm hover:shadow-lg transition-shadow duration-300 rounded-lg bg-card">
              <CardHeader className="pb-4 border-b border-border/50 mb-4">
                <CardTitle className="text-xl font-default flex items-center gap-2 text-primary">
                  <MapPin className="w-5 h-5 shrink-0" />
                  {region.name}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4">
                  {communities.filter(c => c.regionId === region.id).map((community, j) => <li key={j} data-index={j} className="text-muted-foreground flex items-center gap-2 text-sm font-sans hover:text-primary transition-colors">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary shrink-0"></span>
                        {community.name}
                      </li>)}
                </ul>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}